import { render, staticRenderFns } from "./DownloadClient.vue?vue&type=template&id=9c7973e2"
import script from "./DownloadClient.vue?vue&type=script&lang=js"
export * from "./DownloadClient.vue?vue&type=script&lang=js"
import style0 from "./DownloadClient.vue?vue&type=style&index=0&id=9c7973e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports